import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

const DINE_CASH_CONTAINER_PADDING_BOTTOM = "100px";

export const TopSection = styled.div<{ poolingStarted?: boolean; hasLottie?: boolean }>(
    ({ poolingStarted = false, hasLottie = false }) => ({
        position: "relative",
        zIndex: 1,
        width: "100%",
        ...(hasLottie ? { height: poolingStarted ? "322px" : "395px" } : {}),
        flexShrink: 0,
        overflow: "hidden",
    }),
);

export const Header = styled.div(({ theme }) => ({
    position: "fixed",
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    paddingTop: `calc(${theme.spacing.large} + var(--sat, 0px))`,
    paddingLeft: theme.spacing.xLarge,
    paddingRight: theme.spacing.xLarge,
    paddingBottom: theme.spacing.medium,
}));

export const LottieWrapper = styled.div({
    position: "absolute",
    inset: 0,
    pointerEvents: "none",
    zIndex: 0,
});

export const ContentWrapper = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.medium,
    padding: `0 ${theme.spacing.xLarge} ${theme.spacing.xxLarge}`,
}));

export const ScrollableContent = styled.div(({ theme }) => ({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    paddingBottom: `calc(${theme.spacing.medium} + ${DINE_CASH_CONTAINER_PADDING_BOTTOM} + var(--sab, 0px))`,
    scrollbarWidth: "none",
    "&::-webkit-scrollbar": {
        display: "none",
    },
}));

export const Container = styled.div(({ theme }) => ({
    position: "relative",
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    boxSizing: "border-box",
    background: `linear-gradient(191deg, #AAF4D7 0%, ${theme.colors[theme.colorMode].background_Primary} 68%)`,
}));

export const HowItWorksCard = styled.div(({ theme }) => ({
    borderRadius: theme.cornerRadius.medium,
    overflow: "hidden",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    border: `1px solid ${theme.colors[theme.colorMode].border_Tertiary}`,
}));

export const HowItWorksHeader = styled.div(({ theme }) => ({
    backgroundColor: theme.colors[theme.colorMode].positive_Sub,
    padding: `${theme.spacing.medium} ${theme.spacing.large}`,
}));

export const HowItWorksTitle = styled(Text)({
    textTransform: "uppercase",
});

export const HowItWorksBody = styled.div(({ theme }) => ({
    padding: theme.spacing.small,
}));

export const StepList = styled.ol`
    list-style: none;
    padding: 0;
    margin: 0;
`;

export const StepItem = styled.li`
    display: flex;
    gap: 12px;
    align-items: stretch;
`;

export const StepNumberColumn = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
`;

export const StepCircle = styled.div(({ theme }) => ({
    width: theme.spacing.medium,
    height: theme.spacing.medium,
    borderRadius: "50%",
    backgroundColor: theme.colors[theme.colorMode].positive,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
}));

export const StepConnector = styled.div<{ visible?: boolean }>(({ theme, visible = true }) => ({
    width: theme.spacing.xxxSmall,
    flex: 1,
    backgroundColor: theme.colors[theme.colorMode].positive,
    minHeight: theme.spacing.medium,
    visibility: visible ? "visible" : "hidden",
}));

export const StepText = styled(Text)(({ theme }) => ({
    paddingBottom: theme.spacing.medium,
}));

export const DoneButtonWrapper = styled.div(({ theme }) => ({
    position: "absolute",
    bottom: `calc(${theme.spacing.large} + var(--sab, 0px))`,
    left: theme.spacing.medium,
    right: theme.spacing.medium,
    paddingTop: theme.spacing.xxLarge,
    background: `linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, ${theme.colors[theme.colorMode].background_Primary} 30.09%)`,
}));
